export function safeReturnPath(value: string | null, origin: string): string {
  if (!value || value.length > 2048) return '/';
  try {
    const url = new URL(value, origin);
    if (url.origin !== origin || !['/', '/pair', '/invite'].includes(url.pathname))
      return '/';
    // Invitation capabilities stay in this tab's session storage across OAuth.
    // Never copy their fragment/query into Google's or Clerk's redirect URLs.
    if (url.pathname === '/invite') return '/invite';
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/';
  }
}

export function isAuthLocation(path: string, hash: string): boolean {
  return (
    ['/sign-in', '/sign-up'].some(
      (p) => path === p || path.startsWith(`${p}/`),
    ) || hash.startsWith('#/sso-callback')
  );
}

export function authReturnPath(
  search: string,
  hash: string,
  origin: string,
): string {
  const query = new URLSearchParams(search);
  const legacy = new URLSearchParams(hash.split('?')[1] || '');
  return safeReturnPath(
    query.get('return_to') ||
      query.get('sign_in_force_redirect_url') ||
      query.get('sign_up_force_redirect_url') ||
      legacy.get('sign_in_force_redirect_url') ||
      legacy.get('sign_up_force_redirect_url'),
    origin,
  );
}
